<template>
  <CFooter :fixed="false">
    <div>
      
    </div>
    <div class="ml-auto">
      <!-- <span class="mr-1" target="_blank">Powered by</span>
      <a href="https://coreui.io/vue">CoreUI for Vue</a> -->
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>

